export const facilityData = [
  {
    id: "accommodations",
    title: "Comfortable Accommodation",
    category: "Living Spaces",
    shortDescription: "Flexible residential accommodation designed to support both short-term stabilization and long-term psychiatric rehabilitation with maximum dignity and comfort.",
    image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&w=1200&q=80",
    features: [
      "Private Rooms for Individual Care",
      "General Wards & Rooms",
      "2–3 Sharing Rooms",
      "Short-Term Clinical Care Programs",
      "Long-Term Residential Care Options",
      "Care for patients with or without relatives' assistance"
    ]
  },
  {
    id: "care-team",
    title: "Professional Care Team",
    category: "Care & Supervision",
    shortDescription: "Patients receive continuous support from an experienced multidisciplinary team focused on psychiatric care, medical monitoring, nursing, and daily assistance.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=1200&q=80",
    features: [
      "Experienced Consultant Psychiatrist",
      "General Physician for Medical Health",
      "Duty Medical Officers",
      "24/7 Dedicated Nursing Staff",
      "Clinical Psychologist",
      "Psychiatric MSW (Medical Social Worker)",
      "Trained Attendants & Caretakers"
    ]
  },
  {
    id: "nutritious-food",
    title: "Healthy & Nutritious Meals",
    category: "Daily Living",
    shortDescription: "Nutritious, hygienic, and wholesome meals prepared as part of a structured daily routine supporting neurochemical recovery and physical health.",
    image: "https://images.unsplash.com/photo-1498837167922-ddd27525d352?auto=format&fit=crop&w=1200&q=80",
    features: [
      "Nutritious Breakfast Routine",
      "Fresh & Balanced Lunch",
      "Wholesome Dinner Prepared Daily",
      "Tea & Coffee Served Twice a Day",
      "Hygienic Dining & Dietary Supervision"
    ]
  },
  {
    id: "hot-cold-water",
    title: "24/7 Hot & Cold Water",
    category: "Hygiene & Comfort",
    shortDescription: "Continuous water supply across all patient wings equipped with geyser facilities to ensure comfortable bathing, sanitization, and personal hygiene round the clock.",
    image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&w=1200&q=80",
    features: [
      "Geyser Facilities Installed",
      "24/7 Hot & Cold Water Supply",
      "Uninterrupted Flow Across All Bathrooms",
      "Clean & Filtered Water for Daily Use"
    ]
  },
  {
    id: "washrooms",
    title: "Attached Washroom Facilities",
    category: "Hygiene & Comfort",
    shortDescription: "Clean, safely maintained, and regularly sanitized attached washrooms with choices between Indian and Western toilets tailored to patient comfort.",
    image: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?auto=format&fit=crop&w=1200&q=80",
    features: [
      "Attached Indian Toilet Accommodations",
      "Attached Western Toilet Accommodations",
      "Regular Daily Sanitization & Cleaning",
      "Slip-Resistant & Patient-Safe Layouts"
    ]
  },
  {
    id: "power-backup",
    title: "Reliable Power Backup",
    category: "Utilities & Safety",
    shortDescription: "Uninterrupted electrical supply backed by automatic generator systems to maintain continuous lighting, ventilation, and clinical equipment functioning.",
    image: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&w=1200&q=80",
    features: [
      "24/7 Continuous Electricity Supply",
      "Heavy-Duty Generator Backup",
      "Immediate Automatic Switchover",
      "Unbroken Lighting & Clinical Device Power"
    ]
  },
  {
    id: "indoor-games",
    title: "Indoor Recreation & Games",
    category: "Recreation & Wellness",
    shortDescription: "Stimulating indoor board games and mind activities designed to promote cognitive sharpness, stress relief, strategy, and positive social bonding.",
    image: "https://images.unsplash.com/photo-1610890716171-6b1bb98ffd09?auto=format&fit=crop&w=1200&q=80",
    features: [
      "Chess for Cognitive Focus",
      "Carrom for Coordination & Fun",
      "Ludo for Social Engagement",
      "Supervised Indoor Activity Hours"
    ]
  },
  {
    id: "outdoor-activities",
    title: "Outdoor Activities & Group Games",
    category: "Recreation & Wellness",
    shortDescription: "Supervised outdoor group games and physical activities that encourage somatic movement, teamwork, fresh air exposure, and emotional release.",
    image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=1200&q=80",
    features: [
      "Cricket Matches & Fielding Practice",
      "Ball Passing Coordination Games",
      "Musical Chairs & Musical Interaction",
      "Open Grounds for Fresh Air & Sunshine"
    ]
  },
  {
    id: "entertainment",
    title: "Television & Entertainment",
    category: "Recreation & Wellness",
    shortDescription: "Curated audio-visual and musical setups that provide healthy relaxation, group bonding, musical expression, and recreational enjoyment.",
    image: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=1200&q=80",
    features: [
      "Television Set with Curated Viewing",
      "Karaoke Set for Musical Expression",
      "Dedicated High-Fidelity Speaker Setup",
      "Microphone for Community & Speech Activities"
    ]
  },
  {
    id: "library",
    title: "Therapeutic & Knowledge Library",
    category: "Cognitive & Library",
    shortDescription: "Access to a curated collection of educational, spiritual, recovery-oriented, and recreational literature that supports reflection and mental growth.",
    image: "https://images.unsplash.com/photo-1521587760476-6c12a4b040da?auto=format&fit=crop&w=1200&q=80",
    features: [
      "Spiritual & Philosophical Books",
      "Inspiring Autobiographies",
      "Alcoholics Anonymous (AA) Literature",
      "Introduction to Mental Illnesses Books",
      "Scientific & Medical Research Editions",
      "Story Books & Historical Novels",
      "Poetry & Literature Collections"
    ]
  },
  {
    id: "transportation",
    title: "Transportation Support Across Maharashtra",
    category: "Support Services",
    shortDescription: "Safe and dependable patient pickup and transport services operating across all districts of Maharashtra to ensure stress-free admissions.",
    image: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=1200&q=80",
    features: [
      "Pickup Facility Across Maharashtra",
      "Safe, Supervised Patient Transport",
      "Coordination with Hospital Admissions Desk",
      "Comfortable & Prompt Outstation Assistance"
    ]
  },
  {
    id: "home-visit",
    title: "Home Visit Facility",
    category: "Support Services",
    shortDescription: "Professional home care and clinical visit facilities to assess patient requirements, provide guidance to family members, and assist with admission planning.",
    image: "https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?auto=format&fit=crop&w=1200&q=80",
    features: [
      "Professional Home Visit Facility",
      "At-Home Clinical Assessments",
      "Family Guidance & Pre-Admission Support",
      "Care Planning in Patient's Familiar Setting"
    ]
  }
];

export const facilityHighlights = [
  { label: "Multidisciplinary Care", value: "24/7 Dedicated Care Team" },
  { label: "Accommodations", value: "Private & Sharing Rooms" },
  { label: "Patient Amenities", value: "12+ Clinical & Daily Facilities" },
  { label: "Transportation", value: "Maharashtra-Wide Pickup" }
];
